export default __webpack_public_path__ + "static/Pale-b5929337baa5b3e8634556111b101318.png";